import React, { useEffect, useState } from 'react'
import MrbgFormsCreator from './MrbgFormsCreator.jsx'
import { formsJson } from '../../mrbgLib/formsJson.js'
import MP_timeLinePopup from '../../static/css/MP_timeLinePopup.module.css'
import { mrbgStore, setActivePopups } from './mrbgRedux/index.js'
import mrbgS2S from '../../mrbgLib/mrbgS2S.js'

function MrbgSpecialDateTimeLinePopUp({formsJsKey,formStyle}){

  const
    [activePopup,setActivePopUp] = useState(false),
    [formSetting,setFormSetting] = useState(mrbgStore.getState().formsSettings.specialDate);

  useEffect(() => {
    if( formSetting.sundryField?.beginDateTime ){
      var MD = new FormData();
      MD.append( 'beginDateTime', formSetting.sundryField?.beginDateTime );
      mrbgS2S(null, MD, 'dayInf', 'apoSes' );
    }
  }, [formSetting]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setActivePopUp( mrbgStore.getState().activePopups.fullPU )
      setFormSetting( mrbgStore.getState().formsSettings.specialDate );
    })
    return () =>unsubscribe();
  },[])

  if( formsJsKey==='EP' && Object.hasOwn(formsJson.EP.apoSes?.forms,'specialDate') )
    return(
      <div id={MP_timeLinePopup.MrbgSpecialDateTimeLinePopUp} className={activePopup==='MrbgSpecialDateTimeLinePopUp'? MP_timeLinePopup.active:''}>
        <i className="fa-regular fa-close" onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU:''}))}></i>
        <MrbgFormsCreator {...{formID:'specialDate',...formsJson.EP.apoSes.forms.specialDate,formStyle}}/>
      </div>
    )

  return '';
}

export default MrbgSpecialDateTimeLinePopUp;